import { render, staticRenderFns } from "./k1_result.vue?vue&type=template&id=ca4a8da2&"
import script from "./k1_result.vue?vue&type=script&lang=js&"
export * from "./k1_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports